export default __webpack_public_path__ + "static/media/bbt-bnb.7ea63cc0.png";